module.exports = __webpack_public_path__ + "static/no_sweast-895b3ec7acd2ace4f715216394e65efe.webp";